const {ValidationError} = require('./exception.js');
const selector = require('./selector.js');
const selector_application_section=selector.application_section;

const { 
    disable_tab_stop_in_section,
    active_tab_stop_in_active_slide,
    set_progress
} = require('./util.js');

const ary_progress=[
    0,
    7.7,
    15.4,
    23.1,
    30.8,
    38.5,
    46.2,
    53.9,
    61.6,
    69.3,
    77,
    84.7,
    92.4,
    100.1,
];


let handler_table = [];
let ary_form_page;

module.exports.on_jump = (current_slide_name,handler_next=null,handler_previous=null) => {
    let entry = {
        current_slide_name:current_slide_name,
        handler_next:handler_next,
        handler_previous:handler_previous
    }
    handler_table.push(entry);
}

module.exports.prepare_ary_form_page = () => {
    ary_form_page=[];

    //{name:'first',skip=false}
    let ary_DOM_slide;
    ary_DOM_slide = document.querySelectorAll(`${selector_application_section} .swiper-slide`);

    for(var DOM_slide of ary_DOM_slide){
        let slide_name;
        if(!('slideName' in DOM_slide.dataset)) {
            throw new Error('attr data-slide-name required in application slide');
        }
        slide_name = DOM_slide.dataset['slideName'];
        ary_form_page.push({
            name:slide_name,
            skip:false,
        })
    }
}

module.exports.set_skip = (slide_name) => {

    let form_index = ary_form_page.findIndex(entry => (entry.name === slide_name));
    if(form_index === -1) return;

    let selector_ignore_form_page=`${selector_application_section} [data-slide-name="${slide_name}"] input[name*="ignore"]`;
    let DOM_ignore_form_page = document.querySelector(selector_ignore_form_page);

    if(DOM_ignore_form_page == null){
        throw new Error('cant set ignore flag(set_skip)');
    }
    DOM_ignore_form_page.value="1";

    ary_form_page[form_index].skip=true;

}

module.exports.reset_skip = () => {
    let selector_ignore_form_page=`${selector_application_section} [data-slide-name*="entry"] input[name*="ignore"]`;        
    let ary_DOM_ignore_form_page = document.querySelectorAll(selector_ignore_form_page);
    for(var i=0;i<ary_form_page.length;i++){
        ary_form_page[i].skip=false;
    }

    for(var DOM_ignore_form_page of ary_DOM_ignore_form_page){
        DOM_ignore_form_page.value="0";
    }
    
}

module.exports.go_next = async (event,application_swiper) => {
    let currentIndex = application_swiper.activeIndex;
    let nextIndex=currentIndex;
    let current_slide_name;
    let parcentage=null;
    current_slide_name = application_swiper.slides[currentIndex].dataset['slideName'];
    

    try {
        await dispatch_on_jump_handler('next',event,current_slide_name,application_swiper);
    } catch(err){
        if (!(err instanceof ValidationError)) {
            throw err;
        }             
        console.log(err);
        return;
    }

    disable_tab_stop_in_section(application_swiper);

    while(application_swiper.slides[nextIndex] !== void(0)){
        nextIndex++;
        if(ary_form_page[nextIndex] === void(0)) break;
        if(ary_form_page[nextIndex].skip){
            continue;
        } else {
            break;
        }
    }
    application_swiper.slideTo(nextIndex);
    active_tab_stop_in_active_slide(application_swiper);

    parcentage = ary_progress[nextIndex];

    set_progress(parcentage);

    
}

module.exports.go_previous = async (event,application_swiper) => {
        
    let currentIndex = application_swiper.activeIndex;
    let previousIndex=currentIndex;
    let current_slide_name;
    let parcentage=null;
    current_slide_name = application_swiper.slides[currentIndex].dataset['slideName'];

    try {
        await dispatch_on_jump_handler('previous',event,current_slide_name,application_swiper);
    } catch(err){
        if (!(err instanceof ValidationError)) {
            throw err;
        }             
        console.log(err);
        return;
    }

    disable_tab_stop_in_section(application_swiper);

    while(previousIndex in application_swiper.slides){
        previousIndex--;
        if(ary_form_page[previousIndex] === void(0)) break;

        if(ary_form_page[previousIndex].skip){
            continue;
        } else {
            break;
        }
    }
    application_swiper.slideTo(previousIndex);
    active_tab_stop_in_active_slide(application_swiper);

    parcentage = ary_progress[previousIndex];
    set_progress(parcentage);


}


const dispatch_on_jump_handler = async (next_or_prev,event,current_slide_name,application_swiper) => {

    let handler_index = handler_table.findIndex(entry => (entry.current_slide_name === current_slide_name));
    
    if(handler_index === -1) return;
    let entry = handler_table[handler_index];
    switch(next_or_prev){
        case 'next':
            if(entry.handler_next && typeof entry.handler_next === 'function'){
                await entry.handler_next.call(this,event,application_swiper);
            }
            break;
        case 'previous':
            if(entry.handler_previous && typeof entry.handler_previous === 'function'){
                await entry.handler_previous.call(this,event,application_swiper);
            }
            break;
        default:
            throw new Error(`invalid next_or_prev:${next_or_prev}`);
    }
}

